import angular from 'angular'

import statCtrl from './stat.controller'
import statRoutes from './stat.routes'
import statRun from './stat.run'

const name = 'routingConsultStat'

angular.module(name, [])
  .controller('statCtrl', statCtrl)
  .config(statRoutes)
  .run(statRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/stat/stat.module.js